import { withProps } from 'recompose';
import cx from 'classnames';

export default classNameToApply =>
  withProps(({ className }) => ({
    className: cx(className, classNameToApply),
  }));
